<template>
  <div>
    <div
      v-if="routeId"
      class="pvd-container pvd-btn-row"
    >
      <div class="button-group">
        <button
          v-if="showPrimaryButton === 'Y'"
          id="primaryAction"
          :type="primaryButtonType"
          :disabled="disablePrimaryButton === 'Y'"
          class="pvd-btn btn-action loading-button"
          @click.prevent="emitPrimaryButtonClicked()"
        >
          <pvd-loading-spinner
            v-if="showPrimaryButtonSpinner === 'Y'"
            :active="showPrimaryButtonSpinner === 'Y'"
            type="white"
            inline="true"
          />
          {{ primaryButtonLabel }}
        </button>
        <button
          v-if="showSecondaryButton === 'Y'"
          id="secondaryAction"
          type="button"
          :disabled="disableSecondaryButton === 'Y'"
          class="pvd-btn btn-default"
          @click.prevent="emitSecondaryButtonClicked()"
        >
          <pvd-loading-spinner
            v-if="showSecondaryButtonSpinner === 'Y'"
            :active="showSecondaryButtonSpinner === 'Y'"
            inline="true"
          />
          {{ secondaryButtonLabel }}
        </button>
      </div>
      <p
        v-if="!isMaestro() && !isLiteView()"
        class="tertiary-link xsmall"
      >
        <a
          v-if="enableExitModal === 'Y'"
          id="exit-overlay-modal-trigger"
          href="javascript:void(0)"
          @click="handleExitClick"
        >{{ pd_content.exit_link.value }}</a>
        <a
          v-else
          :href="pd_content.exit_link.url"
          @click="handleExitClick"
        >{{ pd_content.exit_link.value }}</a>
      </p>
    </div>
    <ModalComponent
      v-if="enableExitModal === 'Y'"
      :modal-header="pd_content.exit_overlay_modal_header"
      :modal-body1="pd_content.exit_overlay_modal_body1"
      :modal-body2="pd_content.exit_overlay_modal_body2"
      :modal-footer="pd_content.exit_overlay_modal_footer"
      :modal-btn-url="pageExitUrl"
      :modal-btn-val="pd_content.overlay_exit_link.value"
      id-val="exit-overlay-modal"
      @close-action="closeModal"
      @exitmodal-action="exitOverlayModal"
    />
    <apx-page-loading-spinner
      v-if="showPageSpinner === 'Y'"
    />
  </div>
</template>

<script>
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import ModalComponent from './ModalComponent.vue';
import utility from '../mixins/utility';

export default {
  name: 'PageNavigation',
  components: {
    ModalComponent,
  },
  mixins: [
    dataHelper,
    pageNavigationHelper,
    measurement,
    utility,
  ],
  props: {
    primaryButtonType: {
      default: 'button',
      type: String,
    },
    disablePrimaryButton: {
      default: 'N',
      type: String,
    },
    showPrimaryButtonSpinner: {
      default: 'N',
      type: String,
    },
    disableSecondaryButton: {
      default: 'N',
      type: String,
    },
    showSecondaryButtonSpinner: {
      default: 'N',
      type: String,
    },
    showPageSpinner: {
      default: 'N',
      type: String,
    },
    enableExitModal: {
      default: 'Y',
      type: String,
    },
    showPrimaryButton: {
      default: 'Y',
      type: String,
    },
    showSecondaryButton: {
      default: 'Y',
      type: String,
    },

    primaryButtonLabel: {
      default: 'Next',
      type: String,
    },
    secondaryButtonLabel: {
      default: 'Previous',
      type: String,
    },
    pageExitUrl: {
      type: [String, Object],
      default: () => {},
      required: true,
    },
    preventHandlingSecondaryButtonClicked: {
      default: 'N',
      type: String,
    },
  },
  data() {
    return {
      pageContainsInvalidFields: false,
      preventRep: false,
    };
  },
  methods: {
    closeModal() {
      this.track('overlay_close_modal', 'interaction');
      document
        .querySelector('#exit-overlay-modal')
        .setAttribute('active', 'false');
    },
    exitOverlayModal(url) {
      this.track('overlay_exit_link', 'interaction');
      if (typeof url === 'object') {
        this.submitForm(this.createForm(url.url, this.$globalData.tStoreResponse));
      } else if (this.$globalData && this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL
      && this.$globalData.tStoreResponse.exitURL.url) {
        window.location.assign(this.$globalData.tStoreResponse.exitURL.url);
      } else {
        window.location.assign(url);
      }
    },

    emitPrimaryButtonClicked() {
      this.$emit('primary-button-clicked', this.pd_content.primary_button.value);
    },
    emitSecondaryButtonClicked() {
      this.$emit('secondary-button-clicked', this.pd_content.secondary_button.value);
      if (this.preventHandlingSecondaryButtonClicked === 'N') {
        this.handleSecondaryButtonClick(this.pd_content.secondary_button.value);
      }
    },
    handleExitClick() {
      this.track('exit-link', 'interaction');
    },
  },
};
</script>

<style lang="scss">
.pvd-btn-row .button-group button.loading-button {
  flex-direction: row;
}
</style>
